function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/* eslint react/no-danger:0 */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import "./FormInput.css";
var DECIMAL_EXISTS = /.*\..*/;
var COMMA_EXISTS = /.*,.*/;
var KEY_CODES = {
  SPACE: 31,
  COMMA: 44,
  HYPHEN: 45,
  PERIOD: 46,
  ZERO: 48,
  NINE: 57,
  DELETE: 127
};
/**
 * FormInput Component
 **/

var FormInput = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(FormInput, _PureComponent);

  function FormInput(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;

    _this.onAnimationStart = function (_ref) {
      var target = _ref.target,
          animationName = _ref.animationName;

      switch (animationName) {
        case 'onAutoFillCancel':
          _this.setState({
            isAutoFilled: false
          });

          return false;

        case 'onAutoFillStart':
        default:
          _this.setState({
            isAutoFilled: true
          });

          return true;
      }
    };

    _this.focus = function () {
      _this.input.focus();
    };

    _this.handleChange = function (event) {
      if (_this.state.isDirty !== !!event.target.value) {
        _this.setState({
          isDirty: !!event.target.value
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.handleKeyPressCheckNum = function (event) {
      var rtn = true; // Numbers, anything when the ctrl or meta (cmd on mac)
      // key has been pressed and delete are allowed.

      if (event.charCode >= KEY_CODES.ZERO && event.charCode <= KEY_CODES.NINE || event.ctrlKey || event.metaKey || event.charCode === KEY_CODES.DELETE) {
        rtn = true;
      } else if (event.charCode === KEY_CODES.HYPHEN && !_this.props.value || event.charCode === KEY_CODES.PERIOD && !DECIMAL_EXISTS.test(_this.props.value) || event.charCode === KEY_CODES.COMMA && !COMMA_EXISTS.test(_this.props.value)) {
        // Leading minus is allowed for negative numbers. One decimal point
        // also allowed. Some locales use period some use comma for decimal.
        // Forcing the state to dirty because onChange will not fire for a
        // leading minus or leading decimal since the value is not valid
        // yet.
        _this.setState({
          isDirty: true
        });

        rtn = true;
      } else if (event.charCode >= KEY_CODES.SPACE) {
        // Any other non ctrl/meta enabled keys are ignored.
        event.preventDefault();
        rtn = false;
      } // Invoke consumer onKeyPress handler if it exists.


      if (_this.props.onKeyPress) {
        _this.props.onKeyPress(event);
      }

      return rtn;
    };

    _this.state = {
      isAutoFilled: false,
      isDirty: false
    };
    return _this;
  }

  var _proto = FormInput.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.input) {
      this.input.addEventListener('webkitAnimationStart', this.onAnimationStart);
      this.input.addEventListener('animationstart', this.onAnimationStart);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevState.isDirty !== !!this.props.value) {
      if (prevState.isAutoFilled) {
        this.setState({
          isAutoFilled: false
        });
      }

      this.setState({
        isDirty: !!this.props.value
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.input.removeEventListener('webkitAnimationStart', this.onAnimationStart);
    this.input.removeEventListener('animationstart', this.onAnimationStart);
  } // eslint-disable-next-line no-unused-vars
  ;

  // eslint-disable-next-line complexity
  _proto.render = function render() {
    var _this2 = this;

    // Extracting onKeyPress and onChange so they aren't included in ...rest

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        label = _this$props.label,
        leftContent = _this$props.leftContent,
        rightContent = _this$props.rightContent,
        contentClickable = _this$props.contentClickable,
        className = _this$props.className,
        helpText = _this$props.helpText,
        inverse = _this$props.inverse,
        isReadOnly = _this$props.isReadOnly,
        errorMsg = _this$props.errorMsg,
        srOnlyLabel = _this$props.srOnlyLabel,
        inputClassName = _this$props.inputClassName,
        onKeyPress = _this$props.onKeyPress,
        onChange = _this$props.onChange,
        readonly = _this$props.readonly,
        rest = _objectWithoutProperties(_this$props, ["label", "leftContent", "rightContent", "contentClickable", "className", "helpText", "inverse", "isReadOnly", "errorMsg", "srOnlyLabel", "inputClassName", "onKeyPress", "onChange", "readonly"]);
    /* eslint-enable no-unused-vars */


    var notEmpty = this.state.isDirty || this.state.isAutoFilled || !!this.props.value || this.props.type === 'number' && this.props.value === 0 || !!this.props.defaultValue;
    var parentClasses = classNames(className, {
      'form-group': true,
      'floating-label': !srOnlyLabel,
      'not-empty': !!notEmpty,
      empty: !notEmpty,
      'has-icon': !!leftContent,
      'has-feedback': !!rightContent,
      'has-error': !!errorMsg,
      'is-readonly': !!isReadOnly
    });
    var labelClasses = classNames({
      'has-icon': !!leftContent,
      'sr-only': srOnlyLabel
    });
    var inputClasses = classNames('form-control', inputClassName);
    var message = errorMsg || helpText;
    var messageId = this.props.id + "__help";

    var inputProps = _extends(_extends(_extends({
      className: inputClasses,
      'aria-invalid': !!errorMsg,
      ref: function ref(c) {
        return _this2.input = c;
      },
      onChange: this.handleChange,
      onKeyPress: this.props.type === 'number' ? this.handleKeyPressCheckNum : onKeyPress,
      readOnly: readonly || isReadOnly
    }, typeof label === 'string' && {
      'aria-label': label,
      placeholder: label
    }), message && {
      'aria-describedby': messageId
    }), rest);

    var helpProps = _extends({
      className: classNames('help-block', {
        'text-white': inverse
      })
    }, errorMsg && {
      role: 'alert',
      'aria-live': 'polite'
    });

    return /*#__PURE__*/React.createElement("div", {
      className: parentClasses
    }, /*#__PURE__*/React.createElement("input", inputProps), /*#__PURE__*/React.createElement("label", {
      className: labelClasses,
      htmlFor: this.props.id
    }, label), leftContent && /*#__PURE__*/React.createElement("span", {
      className: classNames('form-control-icon', {
        'is-clickable': contentClickable
      })
    }, leftContent), rightContent && /*#__PURE__*/React.createElement("span", {
      className: classNames('form-control-feedback', {
        'is-clickable': contentClickable
      })
    }, rightContent), message && typeof message === 'string' && /*#__PURE__*/React.createElement("span", _extends({}, helpProps, {
      id: messageId,
      dangerouslySetInnerHTML: {
        __html: message
      }
    })), message && typeof message !== 'string' && /*#__PURE__*/React.createElement("div", _extends({}, helpProps, {
      id: messageId
    }), message));
  };

  return FormInput;
}(PureComponent);

FormInput.displayName = 'FormInput';
FormInput.propTypes = {
  /** The Input's id, required for a11y */
  id: PropTypes.string.isRequired,

  /** The Input's label, required for a11y */
  label: PropTypes.node.isRequired,

  /** The actual content of the input */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Input's type */
  type: PropTypes.oneOf(['text', 'password', 'email', 'number', 'tel']),

  /** Want to pass a CSS class to the input? This is your property. */
  inputClassName: PropTypes.string,

  /** Will apply both .is-readonly wrapper classname AND readonly prop to input. Stylistically will remove border and focus state. Use `readonly` prop only to pass attribute to input and retain border (necessary for date pickers) */
  isReadOnly: PropTypes.bool,

  /** For form controls with no visible label, set this to true. Make sure to still add a value to the label property. For screen readers. */
  srOnlyLabel: PropTypes.bool,

  /** Add content to the left of the text. This can be a string, element, or component */
  leftContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),

  /** Add content to the right side of the input box. This can be a string, element, or component */
  rightContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),

  /** If you are sticking content into the input that needs to accept mouse interactions, set this to true. */
  contentClickable: PropTypes.bool,

  /** The help message displayed beneath the input. */
  helpText: PropTypes.node,

  /** The error message displayed beneath the input. Styling of the input will visually indicate an error state. */
  errorMsg: PropTypes.node,

  /** Flag to make helpText and errorMsg use white text for better a11y contrast when used on dark backgrounds */
  inverse: PropTypes.bool,

  /** Called when the value property changes */
  onChange: PropTypes.func,

  /** Called when any key pressed */
  onKeyPress: PropTypes.func
};
FormInput.defaultProps = {
  srOnlyLabel: false,
  contentClickable: false,
  type: 'text',
  inputClassName: ''
};
export default FormInput;
//# sourceMappingURL=FormInput.js.map